import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useHeaderContent } from '../../contexts/HeaderContentContext';
import { useSidebar } from '../../contexts/SidebarContext';

const Layout: React.FC = () => {
  const { headerContent } = useHeaderContent();
  const { isCollapsed, isMobileOpen, closeMobileSidebar } = useSidebar();

  return (
    <div className="min-h-screen bg-gray-50/30 dark:bg-gray-900">
      <Header rightContent={headerContent} />
      
      {/* Mobile Sidebar Overlay */}
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-[89] lg:hidden"
          onClick={closeMobileSidebar}
        />
      )}
      
      <div className="flex">
        <Sidebar />
        <main className={`flex-1 p-0 sm:p-4 lg:p-10 pt-0 sm:pt-4 lg:pt-8 transition-all duration-500 ease-in-out ${
          isCollapsed ? 'lg:pl-20' : 'lg:pl-64'
        } overflow-x-hidden`}>
          <div className="max-w-[1800px] mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;